module.exports = __webpack_public_path__ + "static/media/Rav.40b9562b.jpg";